import { render, staticRenderFns } from "./Xjevaluation.vue?vue&type=template&id=376a96d0&"
import script from "./Xjevaluation.vue?vue&type=script&lang=js&"
export * from "./Xjevaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports